function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_34017",
  "data-name": "Group 34017",
  transform: "translate(0 0)"
}, React.createElement("path", {
  id: "Path_63009",
  "data-name": "Path 63009",
  d: "M23.544,74.969H3.3l2.835-2.6a.837.837,0,0,0,0-1.26,1.044,1.044,0,0,0-1.382,0L.285,75.206A.849.849,0,0,0,0,75.848s0,.008,0,.012a.873.873,0,0,0,.434.741l4.317,3.955a1.045,1.045,0,0,0,1.382,0,.837.837,0,0,0,0-1.26l-2.78-2.547H23.544c4.327,0,7.848,3.212,7.848,7.159s-3.521,7.159-7.848,7.159H16.492a.895.895,0,1,0,0,1.782h7.052c5.4,0,9.8-4.011,9.8-8.941S28.949,74.969,23.544,74.969Z",
  transform: "translate(0 -70.852)",
  fill: "#a6cbf6"
}));
var SvgUndo = function SvgUndo(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 33.346,
    height: 22,
    viewBox: "0 0 33.346 22",
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUndo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undo.2e131a29.svg";
export { ForwardRef as ReactComponent };